$(function(){
    if ($(".campeonato_entre_clubs").length>0){
        var entre_clubs = {
            page:{
                vue:null,
                newVue:function(){
                    entre_clubs.page.vue = new Vue({
                        el:'#entreClubsVueEditarPartidos',
                        data:{
                            partido:{
                                keySp: null,
                                campeonato:{},
                                partido_objeto:{},
                                puede_editar:false,
                                msg_provisional:false,
                                error:null,
                                success:null,
                                id_reg_partidos: null,
                                subPartidos:null,
                                jugadores:{
                                    local:null,
                                    visitante:null
                                },
                                equipos:{
                                  equipo_a:{},
                                    equipo_b:{}
                                },
                                resultado_final:{
                                    puntuacion_local:0,
                                    puntuacion_visitante:0
                                },
                                nombre_acta: '',
                                wo:{},
                                capitan:{
                                    local: null,
                                    visitante: null,
                                    fecha_partido: null,
                                    hora_partido: null
                                },
                                partido_validado : null,
                                modificar_acta: null,
                                comarcal_tennis: null,
                                ver_jugadores_equipo_a: null,
                                ver_jugadores_equipo_b: null,
                                modificar_jugadores: null,
                                usuario_admin: null,
                                partido_empezado: null,
                                usuarios_incompletos: null,
                                usuario_local: null,
                                equipo_a_max_wo_perdidos: 0,
                                equipo_b_max_wo_perdidos: 0,
                                msg_error: '',
                                sanciones: [],
                                tipo_sanciones: [],
                                equipo_selecionado:0,
                                faltan_datos: false,
                                subpartido_wo: 0,

                            },
                            campeonato: false,
                            campeonato_tipo_recurso: 1, // Inicializado a padel
                            is_admin: 0,
                        },
                        methods:{
                            errores_limpiar: function () {
                                var self = this;
                                self.partido.error = null;
                                self.partido.success = null;
                                self.partido.msg_error = '';
                                if (self.partido.subPartidos !== undefined && self.partido.subPartidos !== null){
                                    self.partido.subPartidos.forEach(function (value, key) {
                                        value.error = null;
                                    });
                                }
                            },
                            errores_mostrar: function (res) {
                                var self = this;                                
                                if (typeof res.data.subpartidos!=='undefined') {
                                    Object.keys(res.data.subpartidos).forEach(function (key) {
                                        if (res.data.subpartidos[key].status == 0) {                                
                                            self.partido.subPartidos[key - 1].error = res.data.subpartidos[key].msg;
                                            self.$forceUpdate();
                                        }
                                    });
                                }
                                                                
                                //Mostrem sempre error a nivell global també (per claredat per l'usuari!)
                                self.errores_mostrar_global(res);
                            },
                            errores_mostrar_global: function (res) {
                                var self = this;
                                if (typeof res.data.msg !== "undefined") {
                                    self.partido.msg_error = res.data.msg;
                                    self.$forceUpdate();
                                }

                            },
                            puntos_pareja: function(sp){
                                var self = this;
                                sp.local.puntos_federado_pareja = 0;
                                sp.visitante.puntos_federado_pareja = 0;
                                var puntos_federado;
                                var es_wo = 0;
                                var num_wo = 0;
                                sp.local.jugadores.forEach(function(jugador){
                                    puntos_federado = jugador!==null?jugador.puntos_federado:0;
                                    if(jugador!==null) {
                                        es_wo = jugador.id_reg_inscritos_jugadores>0?0: 1;
                                    } else {
                                        es_wo = 0;
                                    }
                                    num_wo += es_wo;
                                    sp.local.puntos_federado_pareja = sp.local.puntos_federado_pareja + puntos_federado;
                                });
                                sp.visitante.jugadores.forEach(function(jugador){
                                    puntos_federado = jugador!==null?jugador.puntos_federado:0;
                                    if(jugador!==null) {
                                        es_wo = jugador.id_reg_inscritos_jugadores>0?0: 1;
                                    } else {
                                        es_wo = 0;
                                    }
                                    num_wo += es_wo;
                                    sp.visitante.puntos_federado_pareja = sp.visitante.puntos_federado_pareja + puntos_federado;
                                });
                                if (entre_clubs.page.vue.campeonato_tipo_recurso == 1) {
                                    if (num_wo > 0) {
                                        //$(".guardar_acta").addClass('disabled');
                                        //$(".guardar_acta_definitivo").addClass('disabled');
                                    } else {
                                        $(".guardar_acta").removeClass('disabled');
                                        $(".guardar_acta_definitivo").removeClass('disabled');
                                    }
                                }
                                self.$forceUpdate();
                            },
                            guardarActa:function(){
                                var self = this;
                                    self.errores_limpiar();
                                    self.partido.ganaPorWO = '';
                                    self.partido.capitan.fecha_partido = $('#date').val();
                                    self.partido.capitan.hora_partido = $('#time').val().split(":")[0] + ":"+$('#time').val().split(":")[1]+":00";

                                    axios.post('/api/partido/'+self.partido.id_reg_partidos+'/entreClubs/edit/modal/guardarActa',self.partido).then(function(res){
                                        if (res.data.status==0){
                                            self.errores_mostrar(res);
                                        }else if(res.data.status == 2){
                                            self.errores_mostrar_global(res);
                                        }else{
                                            self.partido.success = res.data.msg;
                                            self.$forceUpdate();
                                            if (self.campeonato.id_reg_campeonatos_tipo==2) {
                                                ligaConPartidos.vue.cargarPartidos();
                                                setTimeout(function(){
                                                    self.closeModal();
                                                },1500);
                                            }
                                            if (self.campeonato.id_reg_campeonatos_tipo==1) {
                                                window.location.reload();
                                            }
                                        }
                                    });

                            },

                            guardarActaDefinitivoSendPost:function(){
                                var self = this;
                                self.partido.ganaPorWO = '';
                                axios.post('/api/partido/'+self.partido.id_reg_partidos+'/entreClubs/edit/modal/guardarActaDefinitivo',self.partido).then(function(res){
                                    if (res.data.status==0){
                                        self.errores_mostrar(res);
                                    }else{
                                        self.partido.success = res.data.msg;
                                        self.$forceUpdate();
                                        if (self.campeonato.id_reg_campeonatos_tipo==2) {
                                            ligaConPartidos.vue.cargarPartidos();
                                            setTimeout(function(){
                                                self.closeModal();
                                            },1500);
                                        }
                                        if (self.campeonato.id_reg_campeonatos_tipo==1) {
                                            window.location.reload();
                                        }
                                    }
                                });
                            },
                            guardarActaDefinitivo:function(is_admin){
                                var self = this;
                                self.errores_limpiar();

                                if (is_admin){
                                    self.guardarActaDefinitivoSendPost();
                                }else{
                                    confirmDialog($("#comarcal_guardar_acta_info1").val())
                                        .yes(function(){
                                            self.guardarActaDefinitivoSendPost();
                                        });
                                }

                            },
                            validarUsuariosSinGuardar:function(){
                                var self = this;
                                self.errores_limpiar();
                                axios.post('/api/partido/'+self.partido.id_reg_partidos+'/entreClubs/edit/modal/validarUsuariosSinGuardar',self.partido).then(function(res){
                                    if (res.data.status==0){
                                        self.errores_mostrar(res);
                                    }else{
                                        self.partido.success = res.data.msg;
                                        self.$forceUpdate();
                                    }
                                });
                            },
                            recalcularPuntuacion:function(event){
                                var self = this;
                                self.errores_limpiar();
                                axios.post('/api/partido/'+self.partido.id_reg_partidos+'/entreClubs/edit/modal/recalcularPuntuacion',self.partido).then(function(res){
                                    if (res.data.status==0){
                                        self.errores_mostrar(res);
                                    }else{
                                        self.partido.resultado_final.puntuacion_local = res.data.puntuacion.puntuacion_local;
                                        self.partido.resultado_final.puntuacion_visitante = res.data.puntuacion.puntuacion_visitante
                                        $(event.target).notify(
                                            res.data.msg,
                                            {position: "top", className: 'success'}
                                        );
                                        self.$forceUpdate();
                                    }
                                });
                            },
                            closeModal:function(){
                                this.$refs.editarPuntuacionEntreClubs.close();
                            },
                            ganaPorWo:function(id_reg_equipos){
                                var self = this;
                                axios.post('/api/partido/'+id_reg_equipos+'/entreClubs/edit/modal/validar_wo',self.partido).then(function(res){
                                    if (res.data.status==0){
                                        self.errores_mostrar_global(res);
                                        if ($("#wo_equipo_a_confirm").is(":visible")){
                                            $("#wo_equipo_a_confirm").removeClass("in");
                                        }
                                        if ($("#wo_equipo_b_confirm").is(":visible")){
                                            $("#wo_equipo_b_confirm").removeClass("in");
                                        }
                                    }else{
                                        axios.post('/api/partido/'+self.partido.id_reg_partidos+'/entreClubs/edit/modal/ganaPorWo',{
                                            'id_reg_equipos':id_reg_equipos
                                        }).then(function(){
                                            ligaConPartidos.vue.cargarPartidos();
                                            self.closeModal();
                                        });
                                    }
                                });

                            },
                            deshacerWo:function(){
                                var self = this;
                                axios.post('/api/partido/'+self.partido.id_reg_partidos+'/entreClubs/edit/modal/deshacerWo').then(function(){
                                    ligaConPartidos.vue.cargarPartidos();
                                    self.closeModal();
                                });
                            },
                            subpartido_ganaPorWo:function(id_reg_equipos,keyPartido,local_visitante){
                                var self = this;
                                self.errores_limpiar();

                                self.partido.subPartidos[keyPartido].local_visitante = local_visitante;
                                self.partido.ganaPorWO = local_visitante;

                                // primer fem un guardarActa i si va bé el ganaPorwo
                                axios.post('/api/partido/'+self.partido.id_reg_partidos+'/entreClubs/edit/modal/guardarActa', self.partido).then(function(res){
                                    if (res.data.status==0){
                                        self.partido.subPartidos[keyPartido].error = res.data.msg;
                                        self.errores_mostrar(res);
                                    }else{
                                        self.partido.success = res.data.msg;
                                        self.$forceUpdate();

                                        axios.post('/api/partido/'+self.partido.id_reg_partidos+'/subpartido/'+(keyPartido+1)+'/entreClubs/edit/modal/ganaPorWo',{
                                            'id_reg_equipos':id_reg_equipos,
                                            'local_visitante':local_visitante
                                        }).then(function(){
                                            entre_clubs.page.partidoDataLoad(self.partido.id_reg_partidos);
                                        });
                                    }
                                });
                            },
                            subpartido_deshacerWo:function(keyPartido){
                                    var self = this;
                                    axios.post('/api/partido/'+self.partido.id_reg_partidos+'/subpartido/'+(keyPartido+1)+'/entreClubs/edit/modal/deshacerWo').then(function(){
                                        self.partido.subPartidos[keyPartido].wo.deshacerWoMostrarConfirmacion = false;
                                    }).then(function(){
                                        entre_clubs.page.partidoDataLoad(self.partido.id_reg_partidos);
                                    });
                            },
                            
                            formatearFecha: function (fecha) {
                                if (!fecha) {
                                    return '-';
                                }
                                const partes = fecha.split(' ');
                                const fechaPartes = partes[0].split('-');
                                return fechaPartes[2] + '/' +fechaPartes[1] + '/' +fechaPartes[0] + ' ' +partes[1];
                            },
                            opciones_jugadores: function(tipo, keySp, tipo_recurso) {
                                if (tipo_recurso == 2){
                                    if (tipo == 2){
                                        return this.partido.jugadores.visitante;
                                    }else{
                                        return this.partido.jugadores.local;
                                    }
                                }else{
                                   return this.partido.jugadores.visitante.filter(function(opt) {
                                        return !(opt.id_reg_inscritos_jugadores === 0 && this.partido.subpartido_wo !== (keySp + 1));
                                    }, this);
                                }
                            }
                        },


                    });
                },
                partidoDataLoad: function(id_reg_partidos){
                    entre_clubs.page.vue.errores_limpiar();
                    entre_clubs.page.vue.partido.id_reg_partidos = id_reg_partidos;
                    axios.get('/api/partido/'+entre_clubs.page.vue.partido.id_reg_partidos+'/entreClubs/edit/modal/data').then(function(res){
                        entre_clubs.page.vue.partido.partido_validado = res.data.partido_validado;
                        entre_clubs.page.vue.partido.subPartidos = res.data.subPartidos;
                        entre_clubs.page.vue.campeonato_tipo_recurso = res.data.campeonato.tipo_recurso.tipo;
                        entre_clubs.page.vue.partido.subPartidos.forEach(function(sp){
                            entre_clubs.page.vue.puntos_pareja(sp);
                        });
                        entre_clubs.page.vue.partido.jugadores = res.data.jugadores;
                        entre_clubs.page.vue.partido.resultado_final = res.data.resultado_final;
                        entre_clubs.page.vue.partido.nombre_acta = res.data.nombreEquipos;
                        entre_clubs.page.vue.partido.equipos = res.data.equipos;
                        entre_clubs.page.vue.partido.partido_objeto = res.data.partido_objeto;
                        entre_clubs.page.vue.campeonato = res.data.campeonato;
                        entre_clubs.page.vue.partido.wo = res.data.wo;
                        entre_clubs.page.vue.partido.capitan = res.data.capitan;
                        entre_clubs.page.vue.partido.modificar_acta = res.data.modificar_acta;
                        entre_clubs.page.vue.partido.comarcal_tennis = res.data.comarcal_tennis;
                        entre_clubs.page.vue.partido.ver_jugadores_equipo_a = res.data.ver_jugadores_equipo_a;
                        entre_clubs.page.vue.partido.ver_jugadores_equipo_b = res.data.ver_jugadores_equipo_b;
                        entre_clubs.page.vue.partido.modificar_jugadores = res.data.modificar_jugadores;
                        entre_clubs.page.vue.partido.usuario_admin = res.data.usuario_admin;
                        entre_clubs.page.vue.partido.partido_empezado = res.data.partido_empezado;
                        entre_clubs.page.vue.partido.usuarios_incompletos = res.data.usuarios_incompletos;
                        entre_clubs.page.vue.partido.usuario_local = res.data.usuario_local;
                        entre_clubs.page.vue.partido.usuario_visitante = res.data.usuario_visitante;
                        entre_clubs.page.vue.partido.equipo_a_max_wo_perdidos = res.data.equipo_a_max_wo_perdidos;
                        entre_clubs.page.vue.partido.equipo_b_max_wo_perdidos = res.data.equipo_b_max_wo_perdidos;
                        entre_clubs.page.vue.partido.equipo_a_max_wo_partidos_perdidos = res.data.equipo_a_max_wo_partidos_perdidos;
                        entre_clubs.page.vue.partido.equipo_b_max_wo_partidos_perdidos = res.data.equipo_b_max_wo_partidos_perdidos;
                        entre_clubs.page.vue.partido.msg_provisional = res.data.msg_provisional;
                        entre_clubs.page.vue.partido.subpartido_wo = res.data.subpartido_wo;
                        if ($('#entreClubsPuedeEditar').length>0)
                            entre_clubs.page.vue.partido.puede_editar = $('#entreClubsPuedeEditar').val()=='true'?true:false;
                        else
                            entre_clubs.page.vue.partido.puede_editar = res.data.puede_editar;
                    }).then(function(){
                        //Inicialitzem missatges d'error
                        entre_clubs.page.vue.partido.subPartidos.forEach(function(value,key){
                            value.error = null;
                        });
                    }).then(function(){
                        entre_clubs.page.vue.$forceUpdate();
                        if (typeof entre_clubs.page.vue.$refs.editarPuntuacionEntreClubs!=='undefined')
                            entre_clubs.page.vue.$refs.editarPuntuacionEntreClubs.open();
                    });
                },
                eliminarResultados: function(id_reg_partidos){
                    entre_clubs.page.vue.partido.id_reg_partidos = id_reg_partidos;
                    axios.post('/api/partido/'+entre_clubs.page.vue.partido.id_reg_partidos+'/eliminarResultados').then(function(res){
                        ligaConPartidos.vue.cargarPartidos();
                    });
                },
                cambiarEquipos: function(id_reg_partidos){
                    entre_clubs.page.vue.partido.id_reg_partidos = id_reg_partidos;
                    axios.post('/api/partido/'+entre_clubs.page.vue.partido.id_reg_partidos+'/cambiarEquipos').then(function(res){
                        ligaConPartidos.vue.cargarPartidos();
                    });
                },

                partidoSancionesLoad: function(id_reg_partidos, is_admin){
                    entre_clubs.page.vue.errores_limpiar();
                    entre_clubs.page.vue.partido.id_reg_partidos = id_reg_partidos;
                    entre_clubs.page.vue.is_admin = is_admin;
                    entre_clubs.page.vue.$forceUpdate();
                    
                    axios.get('/api/partido/'+id_reg_partidos+'/entreClubs/sanciones/data').then(function(res){
                        entre_clubs.page.vue.partido.sanciones = res.data.sanciones_partidos;
                        for (var i = 0; i < entre_clubs.page.vue.partido.sanciones.length ; i++) {
                            entre_clubs.page.vue.partido.sanciones[i].fecha_penalizacion = entre_clubs.page.vue.partido.sanciones[i].fecha_penalizacion.split(' ')[0];
                        }
                        entre_clubs.page.vue.partido.tipo_sanciones = res.data.tipo_sanciones;
                        entre_clubs.page.vue.partido.equipos = res.data.equipos;
                        entre_clubs.page.vue.$refs.editarSancionesEntreClubs.open();
                    });

                },

                anadirSancion: function(){
                    var date = new Date();
                    // Obtener el año, mes y día
                    var year = date.getFullYear();
                    var month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11, por eso sumamos 1
                    var day = String(date.getDate()).padStart(2, '0');
                    // Formatear en yyyy-mm-dd
                    var fecha_formateada = year + '-' + month + '-' + day;

                    entre_clubs.page.vue.partido.sanciones.push({
                        id_reg_partidossancion: null,
                        id_mst_tiposancion: 1,
                        id_reg_partidos: entre_clubs.page.vue.partido.id_reg_partidos,
                        id_reg_equipos: null,
                        observaciones: "",
                        penalizacion: 0,
                        fecha_penalizacion: fecha_formateada
                    });
                },

                eliminarSancion: function (key){
                    entre_clubs.page.vue.partido.sanciones.splice(key,1);
                },

                guardarSanciones: function (){
                    axios.post('/api/partido/entreClubs/sanciones/guardar',{sanciones: entre_clubs.page.vue.partido.sanciones, id_reg_partido: entre_clubs.page.vue.partido.id_reg_partidos}).then(function(res){
                        $('#alert_required').hide();
                        if (res.data.status == '0'){
                            $('#alert_required').show();
                        }else{
                            ligaConPartidos.vue.cargarPartidos();
                            entre_clubs.page.vue.$refs.editarSancionesEntreClubs.close();
                        }

                    });
                }
            }
        }

        $(function(){
            entre_clubs.page.newVue();
        });

        $(document).on('click','.editar_puntuacions_btn.entre_clubs',function(e){
            e.preventDefault();
            entre_clubs.page.partidoDataLoad(parseInt($(this).data('id_reg_partidos')));
        });

        $(document).on('click','.eliminar_puntuacions_btn_confirm',function(e){
            e.preventDefault();
            entre_clubs.page.eliminarResultados(parseInt($(this).data('id_reg_partidos')));
        });

        $(document).on('click','.canviar_equips_btn_confirm',function(e){
            e.preventDefault();
            entre_clubs.page.cambiarEquipos(parseInt($(this).data('id_reg_partidos')));
        });

        if ($('#mostrarActaPagina').length>0){
            $(function(){
                entre_clubs.page.partidoDataLoad($("#mostrarActaPagina").data('id_reg_partidos'));
            })
        }

        $(document).on('click','.editar_sanciones_btn.entre_clubs',function(e){
            e.preventDefault();
            entre_clubs.page.partidoSancionesLoad(parseInt($(this).data('id_reg_partidos')),$(this).data('is_admin'));
        });

        $(document).on('click','.eliminar_sanciones_btn_confirm',function(e){
            e.preventDefault();
            entre_clubs.page.eliminarSancion($(this).val());
        });
        $(document).on('click','.guardar_sanciones_btn_confirm',function(e){
            e.preventDefault();
            entre_clubs.page.guardarSanciones();
        });

        $(document).on('click','.anadir_sanciones_btn_confirm',function(e){
            e.preventDefault();
            entre_clubs.page.anadirSancion();
        });
    }
});

$(document).on('change', '.partidoEdit .input-puntuacion', function () {
    validar_puntuacion();
});
